var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegengDespenseLate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0998 1.51726C18.951 0.479202 17.4888 -0.0917324 15.9744 0.0120739C14.4077 0.063977 12.9978 0.738718 12.0056 1.88059L2.39688 12.4169C1.35246 13.5588 0.830251 15.0121 0.882472 16.5173C0.934693 18.0225 1.61357 19.4757 2.76243 20.4619C3.80686 21.4481 5.1646 21.9671 6.57458 21.9671C6.67902 21.9671 6.78346 21.9671 6.8879 21.9671C8.40232 21.8633 9.81229 21.2404 10.8567 20.0986L20.4132 9.56225C21.4576 8.42038 21.9798 6.96709 21.9276 5.41C21.9276 3.90481 21.2487 2.50342 20.0998 1.51726ZM14.7211 12.8321L9.29007 7.95325L13.5722 3.23007C14.2511 2.50342 15.1388 2.0882 16.0788 2.0363C16.131 2.0363 16.1833 2.0363 16.2355 2.0363C17.1232 2.0363 18.011 2.39962 18.6899 3.02245C19.421 3.6972 19.8387 4.57955 19.891 5.5138C19.9432 6.49996 19.5776 7.43422 18.8988 8.16086L14.7211 12.8321Z",
    fill: "#FF3C33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegengDespenseLate);
export default __webpack_public_path__ + "static/media/legeng-despense-late.b4f0c908f38e44fd15d02dd9cd9367db.svg";
export { ForwardRef as ReactComponent };